import styled from 'styled-components'

import { StyledButton } from '../../../components/scharedStyles/style'

export const ExportButton = StyledButton

export const ExportNotice = styled.div`
    margin-bottom: 12px;
    color: #2e74b5;
`

export const ModalHint = styled.p`
    margin: 0 0 12px;
`
